"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _withThemeProps = _interopRequireDefault(require("../withThemeProps"));

var themeSettings = {
  name: 'SxTextDecorations'
};
var useStyles = (0, _styles.makeStyles)(function () {
  return (
    /* theme */
    {
      root: {
        display: 'inline-block'
      },
      lineThrough: {
        textDecoration: 'line-through'
      },
      overline: {
        textDecoration: 'overline'
      },
      underline: {
        textDecoration: 'underline'
      }
    }
  );
});

var TextDecorations = function TextDecorations(_ref) {
  var children = _ref.children,
      pClasses = _ref.classes,
      _ref$decoration = _ref.decoration,
      decoration = _ref$decoration === void 0 ? 'none' : _ref$decoration,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["children", "classes", "decoration"]);
  var classes = useStyles({
    classes: pClasses
  });
  return /*#__PURE__*/_react.default.createElement("span", (0, _extends2.default)({}, rest, {
    className: (0, _clsx.default)(classes.root, "completed strike lineThrough".includes(decoration) && classes.lineThrough, {
      'underline': classes.underline,
      'overline': classes.overline
    }[decoration])
  }), children);
};

process.env.NODE_ENV !== "production" ? TextDecorations.propTypes = {
  /**
     * Content
     */
  children: _propTypes.default.node,

  /**
     * Type of applied decoration.
     */
  decoration: _propTypes.default.oneOf(['none', 'completed', 'strike', 'lineThrough', 'underline', 'overline']),
  ref: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object])
} : void 0;
TextDecorations.displayName = 'TextDecorations';

var _default = (0, _withThemeProps.default)(themeSettings)(TextDecorations);

exports.default = _default;